import { TermType } from "./types";
export function isTerm(obj) {
    return obj && Object.prototype.hasOwnProperty.call(obj, "termType");
}
export function isNamedNode(obj) {
    return isTerm(obj) && obj.termType === TermType.NamedNode;
}
export function isBlankNode(obj) {
    return isTerm(obj) && obj.termType === TermType.BlankNode;
}
export function isLiteral(obj) {
    return isTerm(obj) && obj.termType === TermType.Literal;
}
var TermTypes = [
    TermType.NamedNode.toString(),
    TermType.BlankNode.toString(),
    TermType.Literal.toString()
];
export function isSomeTerm(obj) {
    return isTerm(obj) && TermTypes.includes(obj.termType);
}
var NodeTypes = [TermType.NamedNode.toString(), TermType.BlankNode.toString()];
export function isNode(obj) {
    return isTerm(obj) && NodeTypes.includes(obj.termType);
}
export function isQuad(obj) {
    return obj && Object.prototype.hasOwnProperty.call(obj, "subject");
}
export function doc(node) {
    if (node.value.indexOf('#') < 0) {
        return node.value;
    }
    else {
        return node.value.split('#')[0];
    }
}
